export default __webpack_public_path__ + "static/media/h2.a3f39089.jpg";